import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


export interface DefaultSearchDialogData {
  searchText: string;
}

@Component({
  selector: 'app-default-search-dialog',
  templateUrl: './default-search-dialog.component.html',
  styleUrls: ['./default-search-dialog.component.css']
})
export class DefaultSearchDialogComponent implements OnInit {


  @ViewChild('searchText') searchText: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DefaultSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DefaultSearchDialogData) { }

  onNoClick(): void {

    console.log("Dialogo fechado onNoClick ");
    this.dialogRef.close();
  }

  closeDialog(): void {

    console.log("Dialogo fechado closeDialog ");

  
    this.dialogRef.close(this.data.searchText);
  }

  ngOnInit() {
  }



}


